// Auto-generated - do not edit
export const APP_VERSION = '4.73.0';
